import axios from "axios";

export default {
  http: axios.create({
    withCredentials: true,
    baseURL: "/",
  }),
  mb_base_url: process.env.VUE_APP_MEDIABRAINS_URL,
};
